function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["width", "height", "series", "margin", "xAxis", "yAxis", "zAxis", "colors", "dataset", "sx", "title", "desc", "disableAxisListener", "highlightedItem", "onHighlightChange", "plugins", "children"];
import * as React from 'react';
import useForkRef from '@mui/utils/useForkRef';
import { useDefaultizeAxis } from './useDefaultizeAxis';
import { useReducedMotion } from '../hooks/useReducedMotion';
export const useChartContainerProps = (props, ref) => {
  const width = props.width,
    height = props.height,
    series = props.series,
    margin = props.margin,
    xAxis = props.xAxis,
    yAxis = props.yAxis,
    zAxis = props.zAxis,
    colors = props.colors,
    dataset = props.dataset,
    sx = props.sx,
    title = props.title,
    desc = props.desc,
    disableAxisListener = props.disableAxisListener,
    highlightedItem = props.highlightedItem,
    onHighlightChange = props.onHighlightChange,
    plugins = props.plugins,
    children = props.children,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  const svgRef = React.useRef(null);
  const chartSurfaceRef = useForkRef(ref, svgRef);
  useReducedMotion(); // a11y reduce motion (see: https://react-spring.dev/docs/utilities/use-reduced-motion)

  const _useDefaultizeAxis = useDefaultizeAxis(xAxis, yAxis, dataset),
    _useDefaultizeAxis2 = _slicedToArray(_useDefaultizeAxis, 2),
    defaultizedXAxis = _useDefaultizeAxis2[0],
    defaultizedYAxis = _useDefaultizeAxis2[1];
  const drawingProviderProps = {
    width,
    height,
    margin,
    svgRef
  };
  const pluginProviderProps = {
    plugins
  };
  const seriesProviderProps = {
    series,
    colors,
    dataset
  };
  const cartesianProviderProps = {
    xAxis: defaultizedXAxis,
    yAxis: defaultizedYAxis,
    dataset
  };
  const zAxisContextProps = {
    zAxis,
    dataset
  };
  const highlightedProviderProps = {
    highlightedItem,
    onHighlightChange
  };
  const chartsSurfaceProps = _extends({}, other, {
    width,
    height,
    ref: chartSurfaceRef,
    sx,
    title,
    desc,
    disableAxisListener
  });
  return {
    children,
    drawingProviderProps,
    seriesProviderProps,
    cartesianProviderProps,
    zAxisContextProps,
    highlightedProviderProps,
    chartsSurfaceProps,
    pluginProviderProps,
    xAxis: defaultizedXAxis,
    yAxis: defaultizedYAxis
  };
};